// Wrapper для всех 375px-ориентированных экранов. Source: stage-4-screens.md §4.
// h-dvh (dynamic viewport height) — жёсткая высота во весь viewport. min-h-dvh давал
// body-scroll на длинных экранах, и BottomNav `sticky bottom-0` ползал вместе с
// контентом в iOS WebView (Capacitor). Сейчас фрейм всегда = высоте viewport,
// скролл — внутри `<main overflow-y-auto>`.

import type { ReactNode } from 'react';
import { Capacitor } from '@capacitor/core';
import { cn } from '@/lib/utils';

export function MobileFrame({ children, className }: { children: ReactNode; className?: string }) {
  // Safe-area нужен везде, где платформа рисует контент под статус-баром / home-indicator:
  // iOS Capacitor WebView И iOS Safari/PWA (index.html: viewport-fit=cover) — там
  // getPlatform()==='web', поэтому native-only gate ронял web на iPhone под статус-бар.
  // env(safe-area-inset-*) сам = 0 на устройствах без выреза/индикатора, так что применять
  // можно широко. Исключаем только Android Capacitor: там статус-бар и навигация непрозрачные
  // (StatusBar plugin), и env-инсет давал лишний отступ.
  // Нижний инсет (pb) делает две вещи: (1) safe-area-inset-bottom поднимает BottomNav и
  // нижние кнопки над home-indicator (иначе «срезаются» у кромки); (2) + var(--keyboard-height)
  // поднимает контент над экранной клавиатурой (resize='none' + keyboard-insets.ts). Когда
  // клавиатуры нет — переменная = 0, остаётся только safe-area.
  const isAndroidNative = Capacitor.getPlatform() === 'android';

  return (
    <div
      data-app-frame
      className={cn(
        'mx-auto flex h-dvh max-w-md flex-col overflow-hidden bg-background',
        !isAndroidNative &&
          'pt-[env(safe-area-inset-top)] pb-[calc(env(safe-area-inset-bottom)_+_var(--keyboard-height,0px))]',
        className,
      )}
    >
      {children}
    </div>
  );
}
